import React from 'react'
import {bindAll, isEmpty} from 'lodash'
import Checkbox from '../Checkbox'
import * as constant from '../contants'
import Fade from '../../Utils/Fade'

const questionName = constant.RESIDENCY

export default class Residency extends React.PureComponent {
    constructor(props) {
        super(props)
        let answer = this.getCurrentAnswer(this.props)
        if (isEmpty(answer)) answer = this.initAnswer()
        this.state = {
            checkedYes: answer.options.checkedYes,
            checkedNo: answer.options.checkedNo,
            checkedContinental: answer.options.qualification.checkedContinental,
            checkedAlaska: answer.options.qualification.checkedAlaska,
            checkedHawaii: answer.options.qualification.checkedHawaii
        }
        bindAll(this, ['getCurrentAnswer', 'setCheckedYes', 'setCheckedNo', 'setCheckedContinental', 'setCheckedAlaska', 'setCheckedHawaii', 'setToParentState'])
    }

    componentWillReceiveProps(props) {
        let answer = this.getCurrentAnswer(props)
        if (isEmpty(answer)) answer = this.initAnswer()
        this.setState({
            checkedYes: answer.options.checkedYes,
            checkedNo: answer.options.checkedNo,
            checkedContinental: answer.options.qualification.checkedContinental,
            checkedAlaska: answer.options.qualification.checkedAlaska,
            checkedHawaii: answer.options.qualification.checkedHawaii
        })
    }

    getCurrentAnswer(props) {
        const {answers} = props
        let currentAnswer = {}
        answers.forEach(answer => {
            if (answer.name === questionName) {
                currentAnswer = answer
            }
        })
        return currentAnswer
    }

    initAnswer() {
        return {
            name: questionName,
            options: {
                checkedYes: false,
                checkedNo: false,
                qualification: {
                    checkedContinental: false,
                    checkedAlaska: false,
                    checkedHawaii: false
                }
            }
        }
    }

    setCheckedYes(checkedYes) {
        let {checkedNo, checkedContinental, checkedAlaska, checkedHawaii} = this.state
        if (checkedYes) checkedNo = false
        this.setState({checkedYes, checkedNo})
        this.setToParentState(checkedYes, checkedNo, checkedContinental, checkedAlaska, checkedHawaii)
    }

    setCheckedNo(checkedNo) {
        let {checkedYes, checkedContinental, checkedAlaska, checkedHawaii} = this.state
        if (checkedNo) checkedYes = false
        this.setState({checkedYes, checkedNo})
        this.setToParentState(checkedYes, checkedNo, checkedContinental, checkedAlaska, checkedHawaii)
    }

    setCheckedContinental(checkedContinental) {
        let {checkedYes, checkedNo, checkedAlaska, checkedHawaii} = this.state
        if (checkedContinental) {
            checkedAlaska = false
            checkedHawaii = false
        }
        this.setState({checkedAlaska, checkedHawaii})
        this.setToParentState(checkedYes, checkedNo, checkedContinental, checkedAlaska, checkedHawaii)
    }

    setCheckedAlaska(checkedAlaska) {
        let {checkedYes, checkedNo, checkedContinental, checkedHawaii} = this.state
        if (checkedAlaska) {
            checkedContinental = false
            checkedHawaii = false
        }
        this.setState({checkedContinental, checkedHawaii})
        this.setToParentState(checkedYes, checkedNo, checkedContinental, checkedAlaska, checkedHawaii)
    }

    setCheckedHawaii(checkedHawaii) {
        let {checkedYes, checkedNo, checkedContinental, checkedAlaska} = this.state
        if (checkedHawaii) {
            checkedContinental = false
            checkedAlaska = false
        }
        this.setState({checkedContinental, checkedAlaska})
        this.setToParentState(checkedYes, checkedNo, checkedContinental, checkedAlaska, checkedHawaii)
    }

    setToParentState(checkedYes, checkedNo, checkedContinental, checkedAlaska, checkedHawaii) {
        const answer = {
            name: questionName,
            options: {
                checkedYes: checkedYes,
                checkedNo: checkedNo,
                qualification: {
                    checkedContinental: checkedContinental,
                    checkedAlaska: checkedAlaska,
                    checkedHawaii: checkedHawaii
                }
            }
        }
        this.props.setAnswers(answer)
    }

    render() {
        const {checkedYes, checkedNo, checkedContinental, checkedAlaska, checkedHawaii} = this.state
        const {eligibleData} = this.props
        return (
            <div>
                {
                    !isEmpty(eligibleData) ?
                        <Fade duration={0.5}>
                            <h1 className="question-title text-center">
                                {eligibleData.question}
                            </h1>
                            <div className="question-content">
                                <Checkbox
                                    title={eligibleData.options[0].title}
                                    checked={checkedYes}
                                    clickHandler={this.setCheckedYes}
                                />
                                <Checkbox
                                    title={eligibleData.options[1].title}
                                    checked={checkedNo}
                                    clickHandler={this.setCheckedNo}
                                />
                            </div>
                            {
                                checkedYes ?
                                    <div className="qualification-content wow fadeInDown" data-wow-duration=".7s">
                                        <Checkbox
                                            title={eligibleData.sub.options[0].title}
                                            checked={checkedContinental}
                                            clickHandler={this.setCheckedContinental}
                                        />
                                        <Checkbox
                                            title={eligibleData.sub.options[1].title}
                                            checked={checkedAlaska}
                                            clickHandler={this.setCheckedAlaska}
                                        />
                                        <Checkbox
                                            title={eligibleData.sub.options[2].title}
                                            checked={checkedHawaii}
                                            clickHandler={this.setCheckedHawaii}
                                        />
                                    </div>
                                    :
                                    null
                            }
                        </Fade>
                        :
                        null
                }
            </div>
        )
    }
}